import { useEffect, useState } from 'react'
import { lumi } from '@/lib/lumi'
import PhoneInput from '@/components/PhoneInput'
import {Loader2, AlertCircle, ArrowRight, Leaf} from 'lucide-react'

const BENEFICIOS = [
  'Um sistema online pronto para prospectar clientes qualificados',
  'Uma estratégia poderosa para ter mais clientes, saber como atender e fechar vendas e atendimentos',
  'Jornada das 12 Emoções para liberar dores emocionais, crenças limitantes e elevar seu estado interior',
  'Mentoria e acompanhamento durante 30 dias para você ter resultados financeiros escaláveis',
]

const OPCOES_DEFINE = [
  'Já atuo na área de bem-estar',
  'Estou começando',
  'Ainda não atuo mas tenho interesse',
  'Atuo em outra área e quero migrar',
]

const OPCOES_OBJETIVO = [
  'Quero ter mais clientes',
  'Quero uma nova fonte de renda',
  'Quero profissionalizar meu trabalho',
  'Quero começar do zero',
]

const MONICA_FALLBACK_NOME = 'Mônica Maria'
const MONICA_FALLBACK_TITULO = 'Terapeuta Vibracional e Mentora'

function Mentoria() {
  // Links personalizados por consultora (?c=) foram desativados.
  // A página de Mentoria funciona apenas com o link da administradora.
  const consultora = 'monica'
  const nomeConsultora = MONICA_FALLBACK_NOME
  const tituloConsultora = MONICA_FALLBACK_TITULO

  const [nome, setNome] = useState('')
  const [whatsapp, setWhatsapp] = useState('')
  const [email, setEmail] = useState('')
  const [atuacaoProfissional, setAtuacaoProfissional] = useState('')
  const [comoSeDefine, setComoSeDefine] = useState('')
  const [objetivoPrincipal, setObjetivoPrincipal] = useState('')

  const [enviando, setEnviando] = useState(false)
  const [erro, setErro] = useState('')
  const [enviado, setEnviado] = useState(false)

  useEffect(() => {
    document.title = 'Mentoria — Diagnóstico Saúde e Emoções'
    window.scrollTo(0, 0)
  }, [])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setErro('')

    if (!nome.trim() || !whatsapp.trim() || !email.trim()) {
      setErro('Preencha todos os campos obrigatórios.')
      return
    }
    if (!atuacaoProfissional.trim()) {
      setErro('Informe sua atuação profissional.')
      return
    }
    if (!comoSeDefine) {
      setErro('Selecione como você se define hoje.')
      return
    }
    if (!objetivoPrincipal) {
      setErro('Selecione seu principal objetivo agora.')
      return
    }

    setEnviando(true)
    try {
      const agora = new Date().toISOString()
      await lumi.entities.mentoria.create({
        nome: nome.trim(),
        whatsapp: whatsapp.trim(),
        email: email.trim(),
        atuacaoProfissional: atuacaoProfissional.trim(),
        comoSeDefine,
        objetivoPrincipal,
        consultora,
        status: 'Novo lead',
        dataInscricao: agora,
        creator: consultora,
        createdAt: agora,
        updatedAt: agora,
      })
      setEnviado(true)
    } catch (err) {
      console.error('[mentoria] erro ao salvar inscrição', err)
      setErro('Não foi possível concluir sua inscrição. Tente novamente.')
    } finally {
      setEnviando(false)
    }
  }

  if (enviado) {
    return (
      <div className="min-h-screen bg-[#F8F4EF] flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-3xl border border-[#EDE0D4] shadow-sm p-8 sm:p-10 text-center">
          <div className="w-16 h-16 bg-[#D8F3DC] rounded-full flex items-center justify-center mx-auto mb-5">
            <Leaf className="w-8 h-8 text-[#2D6A4F]" />
          </div>
          <h1 className="font-cormorant text-3xl font-semibold text-[#2C2C2A] mb-3">
            Inscrição recebida! 🌿
          </h1>
          <p className="text-[#5F5E5A] text-base leading-relaxed mb-6">
            Obrigada por se inscrever. Em breve você receberá as instruções de acesso pelo WhatsApp informado.
          </p>
          <p className="font-cormorant text-lg font-semibold text-[#2D6A4F]">
            {nomeConsultora}
          </p>
          {tituloConsultora && (
            <p className="text-sm text-[#5F5E5A]">{tituloConsultora}</p>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#F8F4EF]">
      <header className="bg-white border-b border-[#EDE0D4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4">
          <p className="font-cormorant text-lg sm:text-xl font-semibold text-[#2D6A4F]">
            Diagnóstico Saúde e Emoções
          </p>
        </div>
      </header>

      <main className="px-4 sm:px-6 py-12 sm:py-16">
        <div className="max-w-2xl mx-auto">
          {/* Headline */}
          <div className="text-center mb-8">
            <h1 className="font-cormorant text-3xl sm:text-4xl font-semibold text-[#2C2C2A] leading-tight mb-6">
              Vou te dar <span className="text-[#2D6A4F]">GRATUITAMENTE</span> um sistema, estratégia, terapia e mentoria para escalar seus resultados em 30 dias
            </h1>
          </div>

          {/* Lista de benefícios */}
          <div className="bg-white rounded-3xl border border-[#EDE0D4] shadow-sm p-6 sm:p-8 mb-6">
            <ul className="space-y-4">
              {BENEFICIOS.map(item => (
                <li key={item} className="flex items-start gap-3">
                  <span className="text-xl leading-none flex-shrink-0 mt-0.5">🌿</span>
                  <span className="text-[#2C2C2A] text-sm sm:text-base leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <p className="text-center text-[#5F5E5A] text-base mb-8">
            Preencha o formulário abaixo para garantir seu acesso.
          </p>

          {/* Formulário */}
          <form
            onSubmit={handleSubmit}
            className="bg-white rounded-3xl p-6 sm:p-8 border border-[#EDE0D4] shadow-sm space-y-6"
          >
            {/* Nome */}
            <div>
              <label className="block text-sm font-medium text-[#2C2C2A] mb-1.5">
                Nome completo <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={nome}
                onChange={e => setNome(e.target.value)}
                placeholder="Seu nome completo"
                required
                className="w-full px-4 py-3 rounded-xl border border-[#EDE0D4] bg-[#F8F4EF] text-[#2C2C2A] placeholder-[#B08968]/60 focus:outline-none focus:border-[#52B788] focus:ring-1 focus:ring-[#52B788] transition-colors"
              />
            </div>

            {/* WhatsApp */}
            <div>
              <label className="block text-sm font-medium text-[#2C2C2A] mb-1.5">
                WhatsApp <span className="text-red-500">*</span>
              </label>
              <PhoneInput value={whatsapp} onChange={setWhatsapp} required />
            </div>

            {/* E-mail */}
            <div>
              <label className="block text-sm font-medium text-[#2C2C2A] mb-1.5">
                E-mail <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                className="w-full px-4 py-3 rounded-xl border border-[#EDE0D4] bg-[#F8F4EF] text-[#2C2C2A] placeholder-[#B08968]/60 focus:outline-none focus:border-[#52B788] focus:ring-1 focus:ring-[#52B788] transition-colors"
              />
            </div>

            {/* Atuação profissional */}
            <div>
              <label className="block text-sm font-medium text-[#2C2C2A] mb-1.5">
                Atuação profissional <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={atuacaoProfissional}
                onChange={e => setAtuacaoProfissional(e.target.value)}
                placeholder="Ex: Terapeuta, consultora de vendas, autônoma..."
                required
                className="w-full px-4 py-3 rounded-xl border border-[#EDE0D4] bg-[#F8F4EF] text-[#2C2C2A] placeholder-[#B08968]/60 focus:outline-none focus:border-[#52B788] focus:ring-1 focus:ring-[#52B788] transition-colors"
              />
            </div>

            {/* Como se define hoje */}
            <div>
              <label className="block text-sm font-medium text-[#2C2C2A] mb-3">
                Como você se define hoje? <span className="text-red-500">*</span>
              </label>
              <div className="space-y-2">
                {OPCOES_DEFINE.map(op => (
                  <label
                    key={op}
                    className={`flex items-start gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-all text-sm ${
                      comoSeDefine === op
                        ? 'border-[#52B788] bg-[#D8F3DC]'
                        : 'border-[#EDE0D4] bg-[#F8F4EF] hover:border-[#52B788]/50'
                    }`}
                  >
                    <input
                      type="radio"
                      name="comoSeDefine"
                      value={op}
                      checked={comoSeDefine === op}
                      onChange={() => setComoSeDefine(op)}
                      className="accent-[#2D6A4F] mt-0.5 flex-shrink-0"
                    />
                    <span className="text-[#2C2C2A]">{op}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Objetivo principal */}
            <div>
              <label className="block text-sm font-medium text-[#2C2C2A] mb-3">
                Qual é o seu principal objetivo agora? <span className="text-red-500">*</span>
              </label>
              <div className="space-y-2">
                {OPCOES_OBJETIVO.map(op => (
                  <label
                    key={op}
                    className={`flex items-start gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-all text-sm ${
                      objetivoPrincipal === op
                        ? 'border-[#52B788] bg-[#D8F3DC]'
                        : 'border-[#EDE0D4] bg-[#F8F4EF] hover:border-[#52B788]/50'
                    }`}
                  >
                    <input
                      type="radio"
                      name="objetivoPrincipal"
                      value={op}
                      checked={objetivoPrincipal === op}
                      onChange={() => setObjetivoPrincipal(op)}
                      className="accent-[#2D6A4F] mt-0.5 flex-shrink-0"
                    />
                    <span className="text-[#2C2C2A]">{op}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Erro */}
            {erro && (
              <div className="flex items-start gap-2 bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-sm text-red-700">
                <AlertCircle size={16} className="shrink-0 mt-0.5" />
                <span>{erro}</span>
              </div>
            )}

            {/* Botão */}
            <button
              type="submit"
              disabled={enviando}
              className="w-full flex items-center justify-center gap-2 bg-[#2D6A4F] text-white font-medium px-6 py-4 rounded-full hover:bg-[#1f4f3a] transition-colors disabled:opacity-60 disabled:cursor-not-allowed text-base"
            >
              {enviando ? (
                <>
                  <Loader2 className="animate-spin" size={18} />
                  Enviando...
                </>
              ) : (
                <>
                  Quero meu acesso gratuito
                  <ArrowRight size={18} />
                </>
              )}
            </button>
          </form>
        </div>
      </main>
    </div>
  )
}

export default Mentoria
